/**
 * ¿ESTE CLIENTE PASA LOS FILTROS DE ASEGURADORA Y TIPO DE PÓLIZA?
 *
 * Una SOLA póliza tiene que cumplir todo lo que se pidió a la vez. Si se mira
 * cada condición por separado, un cliente con "Ambetter salud" + "Florida Blue
 * dental" sale al filtrar "Ambetter + dental" (Lissette 2026-06-19 #8).
 *
 * Y con el estado **Activo** elegido, esa póliza también tiene que estar VIVA.
 * Ticket de Jheraldin García (agencia de Maricarmen Nieto), 2026-09-29: al
 * filtrar UNITED HEALTH + Activo salían Anna Gomez, Ermila Sandoval, Felipe
 * Mencho, Jose Monasterios y Moises Verdu. Tienen la visión y el dental de UHC
 * CANCELADOS, pero su salud activa es de otra compañía. El "Activo" miraba al
 * cliente, que sí está activo por la otra póliza, y el filtro de aseguradora
 * aceptaba cualquier póliza de UHC, viva o muerta. Para contar "cuántas pólizas
 * de UHC tengo en pagos", eso infla la cuenta.
 *
 * Cancelada se decide con `esEstatusCancelado`, que también entiende las
 * "Cancelada" que cada agencia se crea con su propio nombre.
 */
import { coincideConSeleccion } from './utils.js';
import { esEstatusCancelado } from './policyStatuses.js';

/**
 * @param {Array} polizas     las pólizas del cliente
 * @param {object} filtros
 * @param {string[]} filtros.aseguradoras  lista elegida; vacía = todas
 * @param {string}   filtros.tipo          tipo de póliza o "all"
 * @param {boolean}  filtros.soloVivas     true cuando el estado elegido es Activo
 */
export function pasaElFiltroDePoliza(polizas, { aseguradoras, tipo, soloVivas }) {
  const sinAseguradora = !Array.isArray(aseguradoras) || aseguradoras.length === 0;
  const sinTipo = !tipo || tipo === 'all';
  if (sinAseguradora && sinTipo) return true;
  return (polizas || []).some((p) =>
    (sinAseguradora || coincideConSeleccion(p.carrier, aseguradoras))
    && (sinTipo || p.type === tipo)
    && (!soloVivas || !esEstatusCancelado(p.status)));
}
